import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Box, Spinner, theme } from '@frameio/vapor';

const PreviewImage = ({ src }: { src: string }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  // Check if the image is already loaded when the component mounts
  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      setIsLoaded(true);
    }
  }, []);

  return (
    <Box height="100%" left="0px" position="absolute" top="0px" width="100%">
      <Box
        alignItems="center"
        bottom="0px"
        display="flex"
        justifyContent="center"
        left="0px"
        position="absolute"
        right="0px"
        top="0px"
      >
        <Spinner
          aria-labelledby="watermark-preview-image"
          isLoading={!isLoaded}
          size="medium"
        />
      </Box>
      <StyledImage
        ref={imgRef}
        $isLoaded={isLoaded}
        alt="A sample image to preview the watermark"
        id="watermark-preview-image"
        onLoad={handleImageLoad}
        src={src}
      />
    </Box>
  );
};

export default PreviewImage;

const StyledImage = styled.img<{ $isLoaded: boolean }>`
  height: 100%;
  left: 0;
  opacity: ${(p) => (p.$isLoaded ? 1 : 0)};
  position: absolute;
  top: 0;
  transition: opacity ${theme.transitions.durations[200]}
    ${theme.transitions.eases.primary};
  width: 100%;
`;
